import Cookies from 'universal-cookie'

const cookies = new Cookies()

const parseErrorMessage = message => {
  if (!message.fields) return message
  return Object.values(message.fields)
    .map(m => m)
    .join(', ')
}

function Client(instanceConfig = {}) {
  this.defaults = instanceConfig
}

Client.prototype.request = function (
  requestUrl,
  { method, body, query = {}, ...customConfig } = {}
) {
  const headers = {
    'Content-Type': 'application/json',
    'X-Api-Key':
      cookies.get('X-Api-Token') || process.env.NEXT_PUBLIC_X_API_TOKEN
  }
  const config = {
    method: this.defaults.method || method,
    credentials: 'include',
    ...customConfig,
    headers: {
      ...headers,
      ...customConfig.headers
    }
  }

  if (body) {
    config.body = body instanceof FormData ? body : JSON.stringify(body)
  }

  if (config.headers['Content-Type'] === 'multipart/form-data') {
    delete config.headers['Content-Type']
  }
  const url = this.defaults.baseUrl
    ? `${this.defaults.baseUrl}${requestUrl}`
    : requestUrl
  return window
    .fetch(stringifyUrl({ url, query }), config)
    .then(async response => {
      const data = await response.json()
      if (response.ok) {
        return data
      } else {
        return Promise.reject(parseErrorMessage(data))
      }
    })
}

for (const method of ['get', 'head', 'options']) {
  Client.prototype[method] = function (url, config = {}) {
    return this.request(url, {
      ...config,
      method: method
    })
  }
}

for (const method of ['post', 'put', 'patch', 'delete']) {
  Client.prototype[method] = function (url, body, config = {}) {
    return this.request(url, {
      ...config,
      method: method,
      body
    })
  }
}

function createInstance(instanceConfig) {
  const context = new Client(instanceConfig)
  const instance = bind(Client.prototype.request, context)
  extend(instance, Client.prototype, context)
  extend(instance, context)
  return instance
}

const client = createInstance()

client.create = function create(instanceConfig) {
  return createInstance({ ...client.defaults, ...instanceConfig })
}

function bind(fn, thisArg) {
  return function wrap(...args) {
    return fn.apply(thisArg, args)
  }
}

function extend(a, b, thisArg) {
  for (const [key, val] of Object.entries(b)) {
    if (thisArg && typeof val === 'function') {
      // eslint-disable-next-line no-param-reassign
      a[key] = bind(val, thisArg)
    } else {
      // eslint-disable-next-line no-param-reassign
      a[key] = val
    }
  }

  return a
}

export default client

function stringifyUrl({ url, query }) {
  const urlObj = new URL(url)

  Object.keys(query).forEach(key => {
    urlObj.searchParams.append(key, query[key])
  })

  return urlObj.toString()
}
